import * as React from 'react';

import GraphitiTableWrapper from 'components/shared/GraphitiTableWrapper';

import columns from './table/columns';

import { InvestmentRiskAssessment } from 'javascript/models';

interface IProps {
  newPath?: string;
  scope?: { [key: string]: string | { [key: string]: string } };
}

export default function table(props: IProps) {
  const { newPath } = props;
  const [shouldUpdateTable, setShouldUpdateTable] = React.useState(false);

  let scope = InvestmentRiskAssessment.selectExtra(['owner_name']).order({ created_at: 'desc' });

  if (props.scope) {
    scope = scope.where(props.scope);
  }

  React.useEffect(() => {
    if (shouldUpdateTable) {
      setShouldUpdateTable(false);
    }
  }, [shouldUpdateTable]);

  const updateTable = () => {
    setShouldUpdateTable(true);
  };

  return (
    <GraphitiTableWrapper
      scope={scope}
      columns={columns(updateTable)}
      hasHeader
      isSearchable={false}
      newPath={newPath}
      newText="Create MIR"
      title="Management Information Reports"
      identifier="investmentRiskAssessment:index"
      shouldUpdateTable={shouldUpdateTable}
    />
  );
}
